// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3rHSC","vLegacy":"SelectSecondary_vLegacy__1rAJC","error":"SelectSecondary_error__6lgDD","disabled":"SelectSecondary_disabled__1TXNk"};